import TextField from '@/components/FormElements/TextField';
import { dybrConfigs } from '@/configs/dybr';
import * as React from 'react';

interface BlogNameFieldProps {
  title: string;
  setTitle: (value: string) => void;
  errorTitle: string;
  setErrorTitle: (value: string) => void;
  validate: () => void;
}

function BlogNameField({
  title,
  setTitle,
  errorTitle,
  setErrorTitle,
  validate
}: BlogNameFieldProps) {
  return (
    <TextField
      id="title"
      type="text"
      value={title}
      meta={{}}
      className=""
      onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
        setTitle(e.target.value);
        setErrorTitle('');
      }}
      label="название дневника"
      maxLen={dybrConfigs.MAX_LENGTH.blogTitle}
      onBlur={validate}
      error={errorTitle}
      touched={Boolean(errorTitle)}
    />
  );
}

export default BlogNameField;
